import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    Typography,
    TableContainer,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead, useTheme
} from '@mui/material'
import {
    CancelRounded, CheckCircleRounded, HelpRounded
} from '@mui/icons-material';
// import Storage from 'react-native-storage';

import {
    CustomAlertHelpDialog, CustomLoadingOverlay, CustomAlertDialog, GenericContainer
    , Buttons
} from '../../components'
import { fileActions, documentsActions, workflowActions, addTitleLegoCurrent } from '../../store/actions'
//// import { mainStyles, theme } from '../../styles'
import { useStyles } from './IdentityValidationStyles'
import { coreFunctions } from '../../utils'//funciones del nucleo
import { useProjectContext, getNameDocINE } from '../../utils'

export default function ExternalValidations(props) {
    const gridContainer = {} //mainStyles.gridStyle()
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()
    const localStyles = useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const context = useProjectContext()

    const [loadView, setLoadView] = useState(false)
    const [modalHelp, setModalHelp] = useState(false)
    const [editButton, setEditButton] = useState(false)

    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [fileId, setFileId] = useState(0)
    const [documentId, setDocumentId] = useState(0)
    const [documentName, setDocumentName] = useState(0)
    const [docName, setDocName] = useState(0)

    const [listControls, setListControls] = useState([])
    const [stageActual, setStageActual] = useState(null)

    const [evaluation1Field, setEvaluation1Field] = useState("RENAPO")
    const [evaluation2Field, setEvaluation2Field] = useState("INE")

    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [openErrorTitle, setOpenErrorTitle] = useState("");
    const [openErrorDescription, setOpenErrorDescription] = useState("");
    const [metadataResults, setMetadataResults] = useState([]);
    const [loadValidateItems, setLoadValidateItems] = useState(false)
    const [isEvaluationIsDataCorrect, setIsEvaluationIsDataCorrect] = useState(false)
    const [isEvaluationIsMinutiaeCorrect, setIsEvaluationIsMinutiaeCorrect] = useState(false)

    // const [timerSeconds, setTimerSeconds] = useState(10)
    const file = useSelector(state => state.FileInfo)
    const auth = useSelector(state => state.Authentication)
    const validaIdentityData = useSelector(state => state.ValIdentityData)
    const folioId = location.state.folioId

    useEffect(() => {
        dispatch(addTitleLegoCurrent("Captura de identificación"))
        setLoadView(true)
        // console.log("File Id: ", location.state.folioId, " Metadatadata Results: ", location.state.metaResults)
        setFileId(location.state.folioId)
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        setMetadataResults(location.state.metaResults)
        setDocName(location.state.docName)
        dispatch(workflowActions.RegisterStatusStage({
            File_id: folioId,
            Status: "Validación"
        }))
    }, [])

    useEffect(() => {
        if (file.items != undefined && file.items?.Stage != undefined && loadView) {
            if (file.items.Stage.Name != "Validación de identidad") {
                let nextStage = file.items.Stage
                let stageName = nextStage.Name
                let stageId = nextStage.Id
                let folioId = fileId
                let stage = file.items.Stage

                let nextComponent = coreFunctions.GetLegoNext(stageName)
                coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
            } else {
                setCurrentStage(file.items.Stage.CurrentStageGroup)
                setTotalStage(file.items.Stage.TotalStageGroups)

                if (docName === undefined || docName === null || docName == "" || docName.length == 0) {
                    setDocName(file.itemNameDoc?.Name)
                }

                var getNameDoc = getNameDocINE(null, file.items.Stage)
                let documentId = getNameDoc?.DocumentId
                if (documentId != undefined && documentId != null && documentId > 0) {
                    setDocumentId(documentId)
                    setDocumentName(getNameDoc?.Name)
                    // console.log("documentId: ", documentId)
                }
            }
        }
    }, [file])

    useEffect(() => {
        if (documentId != 0 && loadView) {
            // setTimerSeconds(20)
            dispatch(documentsActions.ValidateIdentityData({
                "DocumentId": documentId
            }))
            setLoadValidateItems(true)
            setLoadView(true)
        }
    }, [documentId])

    useEffect(() => {
        console.log("validaIdentityData: ", validaIdentityData)
        if (validaIdentityData.items != undefined && loadValidateItems) {
            setLoadView(false)
            setStageActual(validaIdentityData.items)
            let resultIdentity = validaIdentityData.items.Result.IdentityValidationResult
            let result = validaIdentityData.items.Result.IdentityValidationResult.ValidationResults
            console.log("****Result**************************: ", result)
            //TODO: Se agrega el true para no mostrar los resultados de validacion 
            if (result?.length == 0 || true) {
                handleAccepted()
            } else {
                setEvaluation1Field(resultIdentity.Evaluation1Field)
                setEvaluation2Field(resultIdentity.Evaluation2Field)
                setListControls(result)
                if (metadataResults === null || metadataResults === undefined || metadataResults?.length <= 0) {
                    console.log("ENtro---Metadatos---Llenado-------")
                    // setMetadataResults()
                }
                console.log("validaIdentityData.items: ", validaIdentityData.items)
                setIsEvaluationIsDataCorrect(resultIdentity.EvaluationIsDataCorrect)
                setIsEvaluationIsMinutiaeCorrect(resultIdentity.EvaluationIsMinutiaeCorrect)
                if (!resultIdentity.EvaluationIsDataCorrect || !resultIdentity.EvaluationIsMinutiaeCorrect) {
                    setEditButton(true)
                }
            }
        } else if (validaIdentityData.error != undefined && loadValidateItems) {
            setLoadView(false)
            setOpenErrorAlert(true)
            setOpenErrorTitle("Error");
            setOpenErrorDescription(validaIdentityData.error);
        }
    }, [validaIdentityData])

    useEffect(() => {
        if (listControls.length > 0 && loadView) {
            setLoadView(false)
        }
    }, [listControls])

    let handleAccepted = () => {
        let nextStage = stageActual?.Stage
        let stageName = nextStage?.Name
        let stageId = nextStage?.Id
        let folioId = fileId
        let stage = stageActual

        let nextComponent = coreFunctions.GetLegoNext(stageName)
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
    }

    let handleEdit = () => {
        //TODO: Regresa a pantalla de edicion de datos
        setLoadView(true)
        localStorage.setItem('TransactionId', null)
        console.log("isEvaluationIsDataCorrect && isEvaluationIsMinutiaeCorrect: ", isEvaluationIsDataCorrect, isEvaluationIsMinutiaeCorrect)

        if (!isEvaluationIsDataCorrect && isEvaluationIsMinutiaeCorrect) {
            // localStorage.setItem('TransactionId', null)
            dispatch(workflowActions.RegisterStatusStage({
                File_id: folioId,
                Status: "DatosOCR"
            }))

            const docName = documentName
            let documetId = documentId
            const nextComponent = 'ExtractionForm'
            let isEvaluationDataCorrect = isEvaluationIsDataCorrect
            let isEvaluationMinutiaeCorrect = isEvaluationIsMinutiaeCorrect
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, documetId, docName, isEvaluationDataCorrect, isEvaluationMinutiaeCorrect } })
        } else if (!isEvaluationIsDataCorrect && !isEvaluationIsMinutiaeCorrect) {
            // localStorage.setItem('TransactionId', null)
            dispatch(workflowActions.RegisterStatusStage({
                File_id: folioId,
                Status: "DatosOCR"
            }))

            const docName = documentName
            let documetId = documentId
            const nextComponent = 'ExtractionForm'
            let isEvaluationDataCorrect = isEvaluationIsDataCorrect
            let isEvaluationMinutiaeCorrect = isEvaluationIsMinutiaeCorrect
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, documetId, docName, isEvaluationDataCorrect, isEvaluationMinutiaeCorrect } })
        } else if (isEvaluationIsDataCorrect && !isEvaluationIsMinutiaeCorrect) {
            dispatch(workflowActions.RegisterStatusStage({
                File_id: folioId,
                Status: "CargaMinucias"
            }))
            let nextComponent = 'FingerSelectCapture'
            let capturedFinger = 0
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedFinger } })
        }
    }

    const handleClickOpen = () => {
        setModalHelp(true);
    };

    const handleClose = () => {
        setModalHelp(false);
    };

    const handleCloseErrorAlert = () => {
        setOpenErrorAlert(false);
    };

    /***Se agrega de forma temporal para que no muestre nada JCRH:17012024 METLIFE***/
    return(<GenericContainer></GenericContainer>)

    return (<GenericContainer>
        {/* <Typography variant="h6"
            gutterBottom

        >Captura de identificación
            <HelpRounded
                className={localStyles.helpIcon}
                onClick={handleClickOpen}
            />
        </Typography> */}
        <TableContainer className={localStyles.tableResult} >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="left" style={{
                            borderBottom: "none",
                            paddingBottom: 10,
                        }} padding="none"
                            className={localStyles.names}>
                            <Typography variant="subtitle1"></Typography>
                        </TableCell>
                        <TableCell align="center" style={{
                            borderBottom: "none",
                            paddingBottom: 10,
                        }} padding="none"
                            className={localStyles.names}>
                            <Typography variant="subtitle1" >{evaluation2Field}</Typography>
                        </TableCell>
                        <TableCell align="center" style={{
                            borderBottom: "none",
                            paddingBottom: 10,
                        }} padding="none"
                            className={localStyles.names}>
                            <Typography variant="subtitle1">{evaluation1Field}</Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {console.log("listControls: ", listControls)}
                    {listControls.map((row) => (
                        <TableRow>
                            {row.Evaluation1 == "2" || row.Evaluation2 == "2" || row.Evaluation1 == "3"
                                ? <TableCell align="left" style={{
                                    borderBottom: "none",
                                    paddingBottom: 10,
                                }} padding="none"
                                    className={localStyles.names}>
                                    <Typography variant="subtitle1">{row.FieldName}</Typography>
                                    <Typography gutterBottom  >{row.Value}</Typography>
                                </TableCell>
                                : <TableCell align="left" style={{
                                    borderBottom: "none",
                                    paddingBottom: 10,
                                }} padding="none"
                                    className={localStyles.names}>
                                    <Typography variant="subtitle1">{row.FieldName}</Typography>
                                </TableCell>
                            }

                            <TableCell align="center" style={{
                                borderBottom: "none",
                                paddingBottom: 10
                            }} padding="none"
                                className={localStyles.information}>
                                { //INE
                                    row.Evaluation2 == "0" && (row.FieldName == "Índice izquierdo" || row.FieldName == "Índice derecho")
                                        ? <CancelRounded style={{ color: 'red' }} />
                                        : row.Evaluation2 == "0"
                                            ? '' //no se muestra
                                            : row.Evaluation2 == "2"
                                                ? <CancelRounded style={{ color: 'red' }} />
                                                : row.Evaluation2 == "3"
                                                    ? <HelpRounded style={{ color: 'yellow' }} />
                                                    : <CheckCircleRounded style={{ color: 'green' }} /> //aprobado
                                }
                            </TableCell>

                            <TableCell align="center" style={{
                                borderBottom: "none",
                                paddingBottom: 10
                            }} padding="none"
                                className={localStyles.information}>
                                {// RENAPO
                                    row.Evaluation1 == "0"
                                        ? ''
                                        : row.Evaluation1 == "2"
                                            ? <CancelRounded style={{ color: 'red' }} />
                                            : row.Evaluation1 == "3"
                                                ? <HelpRounded style={{ color: 'yellow' }} />
                                                : <CheckCircleRounded style={{ color: 'green' }} />
                                }
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>


        {editButton == 1 ? null :
            <Buttons
                ConfirmButtonText="Aceptar"
                onClickConfirm={handleAccepted}
                marginBottom={95}  />
        }

        {editButton == 1 ?
            <Buttons
                ConfirmButtonText="Editar"
                onClickConfirm={handleEdit} 
                marginBottom={95} />
            : null
        }

        {loadView && <CustomLoadingOverlay active={loadView} text="Espere un momento por favor..." />}
        <CustomAlertDialog open={openErrorAlert}
            closeAction={handleCloseErrorAlert}
            title={openErrorTitle}
            textDescription={openErrorDescription}
            textAcepted="Aceptar"
            aceptedAction={handleCloseErrorAlert}
        />

        <CustomAlertHelpDialog open={modalHelp}
            closeAction={handleClose}
            title="Captura de identificación"
            body={
                <div>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.stageSubTitle}>La revisión para la captura de datos responde a los siguientes estatus:</Typography>
                    <br></br>
                    <Typography variant="subtitle1"
                        gutterBottom
                        className={localStyles.stageSubTitle}>
                        <CheckCircleRounded className={localStyles.helpIconGreen1} onClick={handleClickOpen} />
                        Correcto. Dato verificado con éxito.
                    </Typography>
                    <Typography variant="subtitle1"
                        gutterBottom
                        className={localStyles.stageSubTitle}>
                        <CancelRounded className={localStyles.helpIconRed1} onClick={handleClickOpen} />
                        Incorrecto. Dato no coincide.
                    </Typography>
                    <Typography variant="subtitle1"
                        gutterBottom
                        className={localStyles.stageSubTitle}>
                        <HelpRounded className={localStyles.helpIconYellow1} onClick={handleClickOpen} />
                        Pendiente. No es posible hacer una consulta en este momento, intentalo más tarde.
                    </Typography>
                </div>
            }
        />
    </GenericContainer>);
}